module.exports = __webpack_public_path__ + "media/images/youtube-square-icon-ba33f24e814bc2a4048b04a64d2204ca.png";